module.exports = function() {
  return new Worker(__webpack_public_path__ + "static/js/CodeHighlight.worker_de7a.js");
};